export const REALTOR_PORTAL_BADGE_TITLE = 'Portal realtor';

export const ASSIGNED_LOAN_OFFICER_PREFIX = 'Assigned to';
